import React, { useEffect, useRef } from 'react';
import { Props } from '../form/text-area';
import { MessageTextArea, MessageTextAreaCount } from './textarea.style';
import * as util from './util';

const Textarea: React.FC<TextareaProps> = ({
    rows = 2,
    maxRows = 3,
    textareaAutoResize,
    hasError,
    disabled,
    showCount = false,
    maxLength,
    onChange,
    value,
    ...props
}) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textareaAutoResize) {
            util.autoResizeTextArea(textareaRef.current, maxRows);
        }
    }, [value, textareaAutoResize]);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (maxLength && e.target.value.length > maxLength) {
            return;
        }
        onChange?.(e);
    };

    return (
        <>
            <MessageTextArea
                ref={textareaRef}
                error={!!hasError}
                name="form-message"
                placeHolder="Is this available?"
                aria-required
                id="textarea-message"
                required
                disabled={disabled}
                value={value || ''}
                autoComplete="off"
                onChange={handleChange}
                rows={rows}
                {...props}
            />
            {
                showCount && maxLength && (
                    <MessageTextAreaCount>
                        {value?.length || 0}/{maxLength}
                    </MessageTextAreaCount>
                )
            }
        </>
    );
};

export interface TextareaProps extends Props {
    maxRows?: number;
    showCount?: boolean;
    textareaAutoResize?: boolean;
    hasError?: boolean;
}

export default Textarea;
